module.exports = __webpack_public_path__ + "static/media/number-list.8a915dcd.svg";